export default __webpack_public_path__ + "static/Onsite-cc3fd9d81f1ee3cdd06cb8626fc18c09.mp4";